import type { FormEvent } from 'react';
import { Icon } from '../Icon';

interface PasswordChangeModalProps {
    onClose: () => void;
    handleChangePassword: (e: FormEvent) => void;
    pwCurrent: string;
    setPwCurrent: (v: string) => void;
    pwNew: string;
    setPwNew: (v: string) => void;
    pwNewConfirm: string;
    setPwNewConfirm: (v: string) => void;
    pwError: string;
}

export function PasswordChangeModal({
    onClose,
    handleChangePassword,
    pwCurrent,
    setPwCurrent,
    pwNew,
    setPwNew,
    pwNewConfirm,
    setPwNewConfirm,
    pwError,
}: PasswordChangeModalProps) {
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-2xl max-w-sm w-full p-6 shadow-2xl relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
                >
                    <Icon name="x" className="w-5 h-5" />
                </button>
                <h3 className="text-base font-bold text-slate-900 mb-1 flex items-center gap-2">
                    <Icon name="key" className="w-4 h-4 text-indigo-600" /> 비밀번호 변경
                </h3>
                <p className="text-xs text-slate-500 mb-5">계정 보안을 위해 초기 비밀번호는 반드시 변경해주세요.</p>
                <form onSubmit={handleChangePassword} className="space-y-3 text-xs">
                    <div>
                        <label className="block text-slate-600 font-bold mb-1">현재 비밀번호</label>
                        <input
                            type="password"
                            required
                            value={pwCurrent}
                            onChange={(e) => setPwCurrent(e.target.value)}
                            className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 font-semibold"
                        />
                    </div>
                    <div>
                        <label className="block text-slate-600 font-bold mb-1">새 비밀번호 (8자 이상)</label>
                        <input
                            type="password"
                            required
                            value={pwNew}
                            onChange={(e) => setPwNew(e.target.value)}
                            className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 font-semibold"
                        />
                    </div>
                    <div>
                        <label className="block text-slate-600 font-bold mb-1">새 비밀번호 확인</label>
                        <input
                            type="password"
                            required
                            value={pwNewConfirm}
                            onChange={(e) => setPwNewConfirm(e.target.value)}
                            className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 font-semibold"
                        />
                    </div>
                    {pwError && <p className="text-rose-600 font-semibold text-[11px]">{pwError}</p>}
                    <button
                        type="submit"
                        className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2.5 rounded-xl transition-all shadow-md mt-1"
                    >
                        비밀번호 변경
                    </button>
                </form>
            </div>
        </div>
    );
}
